import { CommonModule } from "@angular/common";
import { Component, inject, OnInit, output, signal, WritableSignal } from "@angular/core";
import { FormArray, FormBuilder, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { IndicationQuoteStepService } from "../../services/indicationQuoteStep.service";
import { PropertyService } from "../../services/property.service";
import { forkJoin, map, Subscription } from "rxjs";
import { GetUserDetails } from "../../models/sessionStorage.model";
import { AuthService } from "../../auth/auth.service";
import { QuoteComparisonComponent } from "../quote-comparison/quote-comparison.component";
import { quoteComparison } from "../../models/RequestQuote";
import { MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { ConfirmationDialogComponent } from '../utils/confirmation-dialog/confirmation-dialog.component';
import { SaveIndicationAndHomeResponse } from "../../models/RequestQuote";
import { ToastService } from "../../services/toast.service";
import { EQBD_HIGH_BPP_RESTRICTED_DESCRIPTIONS, MessageId, ToastType } from "../../enums/config.enum";
import { Router } from "@angular/router";
import { MessageCenterService } from "../../services/messageCenter.service";
import { PolicyAdministrationService } from "../../services/policyAdministration.service";
import { NavigationHandlerService } from "../../services/navigationHandler.service";
import { SpinnerComponent } from "../utils/spinner/spinner.component";
import { SystemAdminService } from "../../services/system-admin.service";
import { EqbdConfirmationDialogComponent } from "../utils/eqbd-confirmation-dialog/eqbd-confirmation-dialog.component";


@Component({
    selector: 'app-request-bind-step',
    standalone: true,
    imports: [MatExpansionModule, MatSnackBarModule, MatDialogModule, CommonModule, FormsModule, ReactiveFormsModule,SpinnerComponent],
    templateUrl: './request-bind-step.component.html',
    styleUrl: './request-bind-step.component.scss',
})
export class RequestBindStepComponent implements OnInit{
    role: number | null = null;
    requestBindAndIssuePolicyStep = signal(4);
    isLoading = signal(false);
    proceedToRequestBindAndIssuePolicyStep = signal(false);
    isQuoteAmendByUWAdmin = signal(false);
    requestBindAndIssuePolicyEmitter = output<number>();
    amendQuoteEmitter = output<boolean>();
    targetPremiumEmitter = output<boolean>();
    saveIndicationHomeEmitter = output();
    additionalFactorInfo = signal([]);
    causeOfLossInfo = signal([]);
    PropertEnhancementInfo = signal([]);
    versionNo = signal<boolean>(false)
    storageData = signal<GetUserDetails | null>(null);
    indicationId = signal<string | null>('');
    quoteId = signal<string | null>('');
    userId = signal<string | null>('');
    branchId = signal<string | null>('');
    selectedPolicyType = signal<any | null>(null);
    fb: FormBuilder = inject(FormBuilder);
    router = inject(Router);
    dialog = inject(MatDialog);
    authService = inject(AuthService);
    indicationQuoteService = inject(IndicationQuoteStepService);
    messageCenterService = inject(MessageCenterService);
    propertyService = inject(PropertyService);
    policyService = inject(PolicyAdministrationService);
    navigationHandler = inject(NavigationHandlerService);
    systemAdminService = inject(SystemAdminService);
    navLogoClickSubscription: any;
    selectedQuote = signal<quoteComparison | null>(null);
    quoteCoverageVersions = signal<any[]>([]);
    // versionCount = 0;
    quoteComparisonSubcription = new Subscription();
    indicationRiskSummaryDetailsEmitter = output<any>();
    policyRiskSummaryDetailsEmitter = output<any>();
    quoteRagDetails: any = signal(null);
    quoteFeedbackMessage = signal('');
    ragIndicationColor: WritableSignal<string> = signal("#A99333");
    indicationQuoteDetails: any = signal(null);
    IndicationNo = signal<string>('Indication No');
    IndicationDate = signal<string>('Indication Date');
    quoteReferredApprovedLock = signal<boolean>(false);
    isInceptionReferralLock = signal<boolean>(false);
    maxAmendLock = signal<boolean>(false);
    policyFeeAmount = signal<number>(0);
    surplusLinesTaxAmount = signal<number>(0);
    additionalSLTaxFeeItems = signal<{ description: string; otherDescription?: string; feeAmount: number }[]>([]);
    toastService = inject(ToastService);
    quoteSummaryForm = this.fb.group({
        address: this.fb.array([]),
        aopDeductibleAmount: [""],
        windDeductibleFlag:[0],
        windDeductibleFactor: [""],
        aopDeductibleDescription:[""],
        windDeductibleDescription:[""],
        causeOfLoss: [""],
        waterDamageAmount: [""],
        vandalismDescription:[""],
        waterDamageDescription:[""],
        vandalismAmount: [""],
        oAndLCoverageAmount: [""],
        propertyExtCoverageType: [""],
        targetPremium: [""],
        triaPremium: [""],
        totalInsuredValue:[""],
        indicationNo: [""],
        indicationDate: [""],
        inspectionFee: [" "],
        inceptionDate:[""],
        eqbdPremium: [""],
        eqbdFlag: [false]

    });

    ngOnInit(): void {
        this.authService.waitForSessionCachesRestored().subscribe(() => {
            this.initializeAfterCacheHydration();
        });
    }

    private initializeAfterCacheHydration(): void {
        
        this.navLogoClickSubscription = this.navigationHandler.logoClick$.subscribe(() => {
            this.onSaveIndicationHomeAction();
        });
        this.targetPremiumEmitter.emit(true);
        this.getQuoteConfig();
        const irStatus = String(sessionStorage.getItem("inceptionStatus"))
        const isreferral = Number(sessionStorage.getItem("isreferral"))
        if (irStatus === "IDR" && isreferral === 1){
            this.isInceptionReferralLock.set(true) 
         }else{
             this.isInceptionReferralLock.set(false)
         }
        if (this.authService.isPolicyType()){
            this.calculatePolicyInspectionFees();
             this.IndicationNo.set("Policy No")
            this.IndicationDate.set("Policy Bound Date")
        }else{
            const storageData = this.authService.getUserDetailsFromStorage();
            this.storageData.set(storageData);
            this.role = storageData.userRole ? Number(storageData.userRole) : null;
            this.userId.set(String(storageData?.userDetails?.userId));
            this.isIndicationType() ? this.indicationId.set(storageData?.indicationId) : this.quoteId.set(storageData.quoteId);
            this.branchId.set(storageData?.branchId);
            const policyTypeId = Number(sessionStorage.getItem("policyTypeId"));
            this.selectedPolicyType.set(policyTypeId)
            this.isQuoteAmendByUWAdmin.set(storageData?.isAmendByUWAdmin === "1" ? true : false);
            const indicationQuoteId = this.isIndicationType() ? this.indicationId() : this.quoteId();
            const branchId = this.branchId();
            this.IndicationNo.set("Quote No")
            this.IndicationDate.set("Quote Issued Date")
            this.handleSaveStep();
            if(indicationQuoteId && branchId){
                this.calculateQuoteInspectionFees();
            }
            this.quoteComparisonSubcription = this.indicationQuoteService.getQuoteComparisonDetails().subscribe({
                next: (result: quoteComparison) => {
                if(result){
                    this.quoteSummaryForm.reset()
                }
                }
            });
        }
    }

    ngOnDestroy(): void {
        if(this.navLogoClickSubscription){
            this.navLogoClickSubscription.unsubscribe();
        }
        this.quoteComparisonSubcription.unsubscribe();
    }

    isUwAdmin(): boolean {
        return this.role === 2;
    }
      
    isSysAdmin(): boolean {
        return this.role === 3;
    }
      
    isBroker(): boolean {
        return this.role === 1;
    }

    isReadOnlyMode(): boolean {
        return sessionStorage.getItem('isReview') === 'true';
    }

    private getEqbdPremiumValue(): number {
        const value = this.quoteSummaryForm.get('eqbdPremium')?.value;
        const numeric = Number(value);
        return isNaN(numeric) ? 0 : numeric;
    }

    getTotalPolicyPremium(): number {
        const safe = (v: unknown): number => {
            const n = Number(v);
            return isNaN(n) ? 0 : n;
        };
        const targetPremium = safe(this.quoteSummaryForm.get('targetPremium')?.value);
        const eqbdPremium = safe(this.quoteSummaryForm.get('eqbdPremium')?.value);
        const inspectionFee = safe(this.quoteSummaryForm.get('inspectionFee')?.value);
        const triaPremium = safe(this.quoteSummaryForm.get('triaPremium')?.value);
        const additionalSum = this.additionalSLTaxFeeItems().reduce((sum, item) => {
            const n = Number(item.feeAmount);
            return sum + (isNaN(n) ? 0 : n);
        }, 0);
        return (
            targetPremium
            + eqbdPremium
            + this.policyFeeAmount()
            + this.surplusLinesTaxAmount()
            + inspectionFee
            + additionalSum
        );
    }

    onConfirmationPopup(message: string){
        const dialog = this.dialog.open(ConfirmationDialogComponent, {
            data: { message: message }
        });
    
        return dialog.afterClosed()
    }

    OnAmendQuote(){
        this.onConfirmationPopup("Do you want to make changes with the quote?")
            .subscribe((result: boolean) => {
            if(result){
                this.indicationQuoteService.amendQuoteByBroker(Number(this.quoteId()), Number(this.branchId()))
                .subscribe({
                    next: (response: SaveIndicationAndHomeResponse) => {
                        if(response && response?.message){
                            this.amendQuoteEmitter.emit(true);
                            sessionStorage.setItem("quoteType","quote")
                            const QuoteReferredDeclined = sessionStorage.getItem("QuoteReferredDeclined")
                            if (QuoteReferredDeclined === "true"){
                                sessionStorage.setItem("QuoteReferredDeclined","false")
                            }
                            sessionStorage.setItem("RagCall","true");

                        }
                    },
                    error: (error: any) => {
                        console.log("error", error);
                        this.toastService.addNotification({message: "System error. Failed to save data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
                        this.messageCenterService.onUpdateSystemUserMessages(true); // update message center get system generated messages
                    }
                })
            }
        });
    }

    onUWAdminAmendQuote(){
        this.onConfirmationPopup("Do you want to make changes with the quote?")
            .subscribe((result: boolean) => {
            if(result){
                this.indicationQuoteService.amendQuoteByUWAdmin(Number(this.quoteId()), Number(this.userId()))
                .subscribe({
                    next: (response: SaveIndicationAndHomeResponse) => {
                        if(response && response?.message){
                            sessionStorage.setItem("isAmendByUWAdmin", "1");
                            this.amendQuoteEmitter.emit(true);
                        }
                    },
                    error: (error: any) => {
                        console.log("error", error);
                        this.toastService.addNotification({message: "System error. Failed to save data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
                        this.messageCenterService.onUpdateSystemUserMessages(true); // update message center get system generated messages
                    }
                })
            }
        });
    }

    onApproveQuote() {
        this.onConfirmationPopup("Are you want to make changes?")
            .subscribe((result: boolean) => {
            if(result){
                this.indicationQuoteService.approveQuote(Number(this.quoteId()), Number(this.userId()))
                .subscribe({
                    next: (response: SaveIndicationAndHomeResponse) => {
                        if(response && response?.message){
                            const msg =  response?.message || "Quote referral approved successfully.";
                            this.toastService.addNotification({message: msg, type: ToastType.Success}); // success notification
                            this.indicationQuoteService.removeIndicationQuoteStorageData(); // clean sessionStorage data
                            this.router.navigate(['/quote']);
                        }
                    },
                    error: (error: any) => {
                        console.log("error", error);
                        this.toastService.addNotification({message: "System error. Failed to save data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
                    }
                })
            }
        });
    }

    onDeclineQuote(){
        this.onConfirmationPopup("Are you want to make changes?")
            .subscribe((result: boolean) => {
            if(result){
                this.indicationQuoteService.denyQuote(Number(this.quoteId()), Number(this.userId()))
                .subscribe({
                    next: (response: SaveIndicationAndHomeResponse) => {
                        if(response && response?.message){
                            const msg =  response?.message || "Quote referral denied.";
                            this.toastService.addNotification({message: msg, type: ToastType.Success}); // success notification
                            this.indicationQuoteService.removeIndicationQuoteStorageData(); // clean sessionStorage data
                            this.router.navigate(['/quote']);
                        }
                    },
                    error: (error: any) => {
                        console.log("error", error);
                        this.toastService.addNotification({message: "System error. Failed to save data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
                    }
                })
            }
        });  
    }

    onSubmitQuote(){
        this.onConfirmationPopup("Are you want to make changes?")
        .subscribe((result: boolean) => {
            if(result){
                this.indicationQuoteService.submitQuote(Number(this.quoteId()), Number(this.userId())).subscribe({
                    next: (response: SaveIndicationAndHomeResponse) => {
                        if(response && response?.message){
                            const msg =  response?.message || "Quote Changes submitted successfully." ;
                            this.toastService.addNotification({message: msg, type: ToastType.Success}); // success notification
                            this.indicationQuoteService.removeIndicationQuoteStorageData(); // clean sessionStorage data
                            this.router.navigate(['/quote']);
                        }
                    },
                    error: (error: any) => {
                        console.log("error", error);
                        this.toastService.addNotification({message: "System error. Failed to save data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
                    }
                });
            }
        });
    }

    getQuoteSummaryDetails(quoteId: number, branchId: number) {
        forkJoin([
            this.propertyService.getCoverageFactors(),
            this.propertyService.getCauseOfLossOptions(),
            this.indicationQuoteService.fetchQuoteCoverageSummaryDetails(quoteId, branchId),
            this.indicationQuoteService.getQuoteRiskSummary(quoteId),
            this.indicationQuoteService.getQuoteFeedbackMessage(MessageId.QuoteFeedbackDefault),
            this.propertyService.getPropertyEnhancementCoverages()
          ]).pipe(
            map(([addnlCoverageFactor, causeOfLossOptions, quoteSummaryDetails, quoteRiskSummary, quoteFeedbackMessage,propExtensionData]) => {
              return {addnlCoverageFactor, causeOfLossOptions, quoteSummaryDetails, quoteRiskSummary, quoteFeedbackMessage,propExtensionData};
            })
          ).subscribe({
            next: (response: any) => {
                const {addnlCoverageFactor, causeOfLossOptions, quoteSummaryDetails, quoteRiskSummary, quoteFeedbackMessage, propExtensionData} = response;
                if(quoteSummaryDetails && quoteSummaryDetails.result && addnlCoverageFactor && causeOfLossOptions && quoteFeedbackMessage, propExtensionData){
                    this.additionalFactorInfo.set(addnlCoverageFactor);
                    this.causeOfLossInfo.set(causeOfLossOptions);
                    this.PropertEnhancementInfo.set(propExtensionData);                 
                    const totalVersions = quoteSummaryDetails.result.length;
                    this.versionNo.set(totalVersions <= 1);
                    this.indicationRiskSummaryDetailsEmitter.emit(quoteRiskSummary);   
                    quoteRiskSummary.status === "Quote - Referral Approved" ? this.quoteReferredApprovedLock.set(true) : this.quoteReferredApprovedLock.set(false);
                    this.quoteFeedbackMessage.set(quoteFeedbackMessage.messageDescription);
                    this.bindRequestQuoteSummaryData(quoteSummaryDetails.result);
                    this.proceedToRequestBindAndIssuePolicyStep.set(true);
                    const status = sessionStorage.getItem("statusRagCall");
                    const statusAvailable = sessionStorage.getItem("statusAvailable");                  
                    const RagCall = sessionStorage.getItem("RagCall");

                     if ( statusAvailable !== "true" || RagCall === "true"){
                        this.fetchQuoteRagdetails();
                    }else{
                        this.getRagData();
                    }
                }  
            },
            error: (error) => {
                this.isLoading.set(false);
                this.toastService.addNotification({message: "System error. Failed to retrieve data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
            }
        })
    }

    getPolicyCoverageSummaryDetails() {
        forkJoin([
            this.propertyService.getCoverageFactors(),
            this.propertyService.getCauseOfLossOptions(),
            this.policyService.getPolicyCoverageSummary(Number(this.authService.getUserDetailsFromStorage()?.policyId), Number(this.authService.getUserDetailsFromStorage()?.branchId)),
            this.indicationQuoteService.getQuoteFeedbackMessage(MessageId.QuoteFeedbackDefault),
            this.propertyService.getPropertyEnhancementCoverages(), 
            this.policyService.getPolicyRiskSummary(Number(this.authService.getUserDetailsFromStorage()?.policyId)), 
        ]).pipe(
            map(([addnlCoverageFactor, causeOfLossOptions, policySummaryDetails, quoteFeedbackMessage, propExtensionData, policyRiskSummary]) => {
              return {addnlCoverageFactor, causeOfLossOptions, policySummaryDetails, quoteFeedbackMessage, propExtensionData, policyRiskSummary };
            })
          ).subscribe({
            next: (response: any) => {
                const {addnlCoverageFactor, causeOfLossOptions, policySummaryDetails, quoteFeedbackMessage, propExtensionData, policyRiskSummary} = response;
                if(policySummaryDetails && policySummaryDetails.result && addnlCoverageFactor && causeOfLossOptions && quoteFeedbackMessage && propExtensionData && policyRiskSummary){
                    this.additionalFactorInfo.set(addnlCoverageFactor);
                    this.causeOfLossInfo.set(causeOfLossOptions);
                    this.PropertEnhancementInfo.set(propExtensionData);
                    this.policyRiskSummaryDetailsEmitter.emit(policyRiskSummary);
                    this.quoteFeedbackMessage.set(quoteFeedbackMessage.messageDescription);
                    this.bindPolicySummaryData(policySummaryDetails.result);
                    this.proceedToRequestBindAndIssuePolicyStep.set(true);
                }  
            },
            error: (error) => {
                this.isLoading.set(false);
                console.log("error", error);
                this.toastService.addNotification({message: "System error. Failed to retrieve data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
            }
        });
    }

    bindRequestQuoteSummaryData(response: any) {
        if (!Array.isArray(response) || response.length === 0) {
            console.error('Response is empty or invalid');
            this.setSLTaxFeeDetails([]);
            return;
        }
        this.quoteCoverageVersions.set(response);
    
        // Find the object with the highest versionNo
        const highestVersionData = response.reduce((prev, current) => {
            return current.versionNo > prev.versionNo ? current : prev;
        });
    
    
        // Ensure addresses and buildings exist
        if (!highestVersionData.addresses || !highestVersionData.buildings) {
            console.error('Addresses or buildings data is missing');
            return;
        }

        this.indicationQuoteService.setSelectedQuoteVersion(highestVersionData) // Set selected quote version
        this.selectedQuote.set(highestVersionData);

    
        // Set addresses and bind data to form
        this.setAddress(highestVersionData.addresses, highestVersionData.buildings);
    
        this.quoteSummaryForm.patchValue({
            aopDeductibleAmount: highestVersionData.aopDeductibleAmount,
            windDeductibleFlag: highestVersionData.windDeductibleFlag,
            windDeductibleFactor: highestVersionData.windDeductibleFactor,
            windDeductibleDescription:highestVersionData.windDeductibleDescription,
            aopDeductibleDescription:highestVersionData.aopDeductibleDescription,
            causeOfLoss: this.getCauseOfLossData(highestVersionData.causeOfLoss),
            waterDamageAmount: highestVersionData.waterDamageAmount,
            vandalismAmount: highestVersionData.vandalismAmount,
            waterDamageDescription:highestVersionData.waterDamageDescription,            
            vandalismDescription:highestVersionData.vandalismDescription,
            oAndLCoverageAmount: highestVersionData.oAndLCoverageAmount,
            propertyExtCoverageType: this.getEnhancementData(highestVersionData.propertyExtCoverageType),
            totalInsuredValue:highestVersionData?.totalInsuredValue,
            targetPremium: highestVersionData.targetPremium,
            triaPremium: highestVersionData?.triaPremium,
            indicationNo: highestVersionData?.quoteNo,
            indicationDate: highestVersionData?.quoteDate,
            inspectionFee:highestVersionData?.inspectionFee,
            inceptionDate:highestVersionData?.policyStartDate,
            eqbdPremium:highestVersionData?.eqbdPremium,
            eqbdFlag: highestVersionData?.eqbdFlag
        });
        this.setSLTaxFeeDetails(highestVersionData?.slTaxFeeDetails || []);
        this.isLoading.set(false);
    }
    

    
    bindRequestQuoteSummaryDataversion(summaryDetails: any) {
        
        this.selectedQuote.set(summaryDetails);
        
        this.setAddress(summaryDetails.addresses, summaryDetails.buildings);
        this.quoteSummaryForm.patchValue({
            aopDeductibleAmount: summaryDetails.aopDeductibleAmount,
            windDeductibleFlag: summaryDetails.windDeductibleFlag,
            windDeductibleFactor: summaryDetails.windDeductibleFactor,
            windDeductibleDescription:summaryDetails.windDeductibleDescription,
            aopDeductibleDescription:summaryDetails.aopDeductibleDescription,
            causeOfLoss: this.getCauseOfLossData(summaryDetails.causeOfLoss),
            waterDamageAmount: summaryDetails.waterDamageAmount,
            vandalismAmount: summaryDetails.vandalismAmount,
            waterDamageDescription:summaryDetails.waterDamageDescription,            
            vandalismDescription:summaryDetails.vandalismDescription,
            oAndLCoverageAmount: summaryDetails.oAndLCoverageAmount,
            totalInsuredValue:summaryDetails?.totalInsuredValue,
            propertyExtCoverageType: this.getEnhancementData(summaryDetails.propertyExtCoverageType),
            targetPremium: summaryDetails.targetPremium,
            triaPremium: summaryDetails.triaPremium,
            indicationNo: summaryDetails?.quoteNo,
            indicationDate: summaryDetails?.quoteDate,
            inspectionFee: summaryDetails?.inspectionFee,
            inceptionDate:summaryDetails?.policyStartDate,
            eqbdPremium:summaryDetails?.eqbdPremium,
            eqbdFlag: summaryDetails?.eqbdFlag
        });
        this.setSLTaxFeeDetails(summaryDetails?.slTaxFeeDetails || []);
        
    }

    bindPolicySummaryData(summaryDetails: any) {
        this.setPolicyAddress(summaryDetails.addresses, summaryDetails.buildings);
        this.quoteSummaryForm.patchValue({
            aopDeductibleAmount: summaryDetails.aopDeductibleAmount,
            windDeductibleFlag: summaryDetails?.windDeductibleFlag,
            windDeductibleFactor: summaryDetails.windDeductibleFactor,
            windDeductibleDescription:summaryDetails?.windDeductibleDescription,
            aopDeductibleDescription:summaryDetails?.aopDeductibleDescription,
            causeOfLoss: this.getCauseOfLossData(summaryDetails.causeOfLoss),
            waterDamageAmount: summaryDetails.waterDamageAmount,
            vandalismAmount: summaryDetails.vandalismAmount,
            waterDamageDescription:summaryDetails?.waterDamageDescription,            
            vandalismDescription:summaryDetails?.vandalismDescription,
            oAndLCoverageAmount: summaryDetails.oAndLCoverageAmount,
            totalInsuredValue:summaryDetails?.totalInsuredValue,
            propertyExtCoverageType: this.getEnhancementData(summaryDetails.propertyExtCoverageType),
            targetPremium: summaryDetails.targetPremium,
            triaPremium: summaryDetails.triaPremium,
            indicationNo: summaryDetails?.policyNo,
            indicationDate: summaryDetails?.policyDate,
            inspectionFee: summaryDetails?.inspectionFee,
            inceptionDate: summaryDetails?.policyStartDate,
            eqbdPremium:summaryDetails?.eqbdPremium,
            eqbdFlag: summaryDetails?.eqbdFlag

        });
        this.setSLTaxFeeDetails(summaryDetails?.slTaxFeeDetails || []);
        this.isLoading.set(false);
    }

    private setSLTaxFeeDetails(slTaxFeeDetails: any[]): void {
        const details = Array.isArray(slTaxFeeDetails) ? slTaxFeeDetails : [];
        let policyFee = 0;
        let surplusLinesTax = 0;
        const additionalItems: { description: string; otherDescription?: string; feeAmount: number }[] = [];

        details.forEach((item: any) => {
            const description = String(item?.slFeeDescription || '').trim();
            const feeAmount = Number(item?.feeAmount ?? 0);
            const amount = isNaN(feeAmount) ? 0 : feeAmount;
            const normalizedDesc = description.toLowerCase();

            if (normalizedDesc === 'policy fee') {
                policyFee = amount;
            } else if (normalizedDesc === 'surplus lines tax') {
                surplusLinesTax = amount;
            } else if (description) {
                additionalItems.push({
                    description,
                    otherDescription: String(item?.otherDescription || '').trim(),
                    feeAmount: amount
                });
            }
        });

        this.policyFeeAmount.set(policyFee);
        this.surplusLinesTaxAmount.set(surplusLinesTax);
        this.additionalSLTaxFeeItems.set(additionalItems);
    }

    getAddressForm(): FormArray {
        return this.quoteSummaryForm.get("address") as FormArray;
    }

    getBuildingForm(indexNumber: number): FormArray{
        return this.getAddressForm().at(indexNumber).get("buildings") as FormArray;
    }

    setAddress(addressData: any[], buildingData: any[]){

        const addressFormArray = this.getAddressForm();
        while (addressFormArray.length !== 0) {
        addressFormArray.removeAt(0);
        }
        
        (addressData ?? []).forEach((address) => {
            const addressGroup = this.fb.group({
              streetNum:address.streetNum,
              streetName: address.streetName,
              unitNum:address.unitNum,
              occupancy: address.occupany,
              city: address.city,
              state: address.state,
              county: address.county,
              zipcode: address.zipcode, 
              businessIncomeLimit: address.businessIncomeLimit,
              additionalPropertyLimit: address?.additionalPropertyLimit,
              locationTIV: address.locationTIV,
              buildings: this.fb.array([])
            });
            this.setBuilding(addressGroup.get('buildings') as FormArray, address.addressId, buildingData);
            this.getAddressForm().push(addressGroup);
        });
    }

    setPolicyAddress(addressData: any[], buildingData: any[]){
        (addressData ?? []).forEach((address) => {
            const addressGroup = this.fb.group({
                streetNum:address.streetNum,
                streetName: address.streetName,
                unitNum:address.unitNum,
                occupancy: address.occupany,
                city: address.city,
                state: address.state,
                county: address.county,
                zipcode: address.zipcode, 
                businessIncomeLimit: address.businessIncomeLimit,
                locationTIV: address.locationTIV,
                additionalPropertyLimit: address?.additionalPropertyLimit,
                buildings: this.fb.array([])
            });
            this.setPolicyBuilding(addressGroup.get('buildings') as FormArray, address.addressId, buildingData);
            this.getAddressForm().push(addressGroup);
        });
    }

    setBuilding(buildingsFormArray: FormArray, addressId: number, buildingsData: any[]) {
        const matchingBuilding: any[] = (buildingsData ?? []).filter(building => building.quoteAddressId === addressId);
        matchingBuilding.forEach((building) => {
            buildingsFormArray.push(this.fb.group({
                buildingName: building.buildingName,
                buildingAge: building.buildingAge,
                buildingLimit: building.buildingLimit,
                businessPropertyLimit: building.businessPropertyLimit,
                additionalCoverageLimit: this.getAdditionalCoverageFactorData(building.otherStructureFactorId),
                oandLFlag: building.oandLFlag,
                oandLDiscription: building?.oandLDiscription
            }));
        });
    }

    setPolicyBuilding(buildingsFormArray: FormArray, addressId: number, buildingsData: any[]) {
        const matchingBuilding: any[] = (buildingsData ?? []).filter(building => building.policyAddressId === addressId);
        matchingBuilding.forEach((building) => {
            buildingsFormArray.push(this.fb.group({
                buildingName: building.buildingName,
                buildingAge: building.buildingAge,
                buildingLimit: building.buildingLimit,
                businessPropertyLimit: building.businessPropertyLimit,
                additionalCoverageLimit: this.getAdditionalCoverageFactorData(building.otherStructureFactorId),
                oandLFlag: building.oandLFlag,
                oandLDiscription: building?.oandLDiscription
            }));
        });
    }



    getEnhancementData(extensionFactorId: number) : string | null {
        if(extensionFactorId) {
            const getPropertyData: any[] = this.PropertEnhancementInfo().filter((propdata: any) => Number(propdata.extensionFactorId) === extensionFactorId);
            
            if(getPropertyData.length > 0) {
                return getPropertyData[0]?.description;
            }else{
                return 'No Enhancement Selected';
            }
        }
        return 'No Enhancement Selected';
    }

    getCauseOfLossData(gencodeId: number) : string | null {
        if(gencodeId) {
            const getCauseOfLossData: any[] = this.causeOfLossInfo().filter((cofloss: any) => Number(cofloss.gencodeId) === gencodeId);
            if(getCauseOfLossData.length > 0) {
                return getCauseOfLossData[0]?.description;
            }else{
                return null;
            }
        }
        return null;
    }

    getAdditionalCoverageFactorData(factorId: number) : string | null {
        if(factorId){
            const getFactorData: any[] = this.additionalFactorInfo().filter((factor: any) => Number(factor.factorId) === factorId);
            if(getFactorData.length > 0) {
                return getFactorData[0]?.factorDescription;
            }else{
                return null;
            }
        }
        return null;
    }

    OnRequestBindAndIssuePolicy(): void{
        this.handleSaveStep();
        this.requestBindAndIssuePolicyEmitter.emit(this.requestBindAndIssuePolicyStep());
    }

    private getEQBDReferralContext(): { id: number; type: string } | null {
        const storageData = this.authService.getUserDetailsFromStorage();
        if (!storageData || storageData?.isPolicyType) {
            return null;
        }
        if (this.isIndicationType()) {
            const indicationId = Number(storageData?.indicationId ?? 0);
            return indicationId ? { id: indicationId, type: 'indication' } : null;
        }
        const quoteId = Number(storageData?.quoteId ?? 0);
        return quoteId ? { id: quoteId, type: 'quote' } : null;
    }

    private openEqbdConfirmationDialog(): void {
        const dialog = this.dialog.open(EqbdConfirmationDialogComponent, {
            data: {
                message: "EQBD is not included in the current version of this quote. To include EQBD, please click Amend Quote. Otherwise, click Request Bind to proceed without EQBD",
                confirmText: "Amend Quote",
                cancelText: "Request Bind"
            }
        });

        dialog.afterClosed().subscribe((result: boolean) => {
            if (result === true) {
                this.OnAmendQuote();
            } else if (result === false) {
                this.OnRequestBindAndIssuePolicy();
            }
        });
    }

    private hasRestrictedOccupancyHighBpp(versionData: any): boolean {
        const restrictedDescriptions = new Set(
            EQBD_HIGH_BPP_RESTRICTED_DESCRIPTIONS.map((desc) => desc.toLowerCase())
        );
        const addresses = Array.isArray(versionData?.addresses) ? versionData.addresses : [];
        const topLevelBuildings = Array.isArray(versionData?.buildings) ? versionData.buildings : [];

        return addresses.some((address: any) => {
            const occupancy = String(address?.occupany ?? address?.occupancy ?? '').trim().toLowerCase();
            if (!restrictedDescriptions.has(occupancy)) {
                return false;
            }

            const directBpp = Number(address?.bppLimit ?? address?.businessPropertyLimit ?? 0);
            const addressBuildings = topLevelBuildings.filter(
                (building: any) => Number(building?.quoteAddressId ?? building?.addressId ?? building?.policyAddressId) === Number(address?.addressId)
            );
            const buildingsToCheck = addressBuildings.length > 0
                ? addressBuildings
                : (Array.isArray(address?.buildings) ? address.buildings : []);
            const maxBuildingBpp = buildingsToCheck.reduce((max: number, building: any) => {
                const bpp = Number(building?.bppLimit ?? building?.businessPropertyLimit ?? 0);
                return isNaN(bpp) ? max : Math.max(max, bpp);
            }, 0);
            const resolvedBpp = !isNaN(directBpp) && directBpp > 0 ? directBpp : maxBuildingBpp;
            return resolvedBpp > 49999;
        });
    }

    onBrokerRequestBind(): void {
        const eqbdPremium = this.getEqbdPremiumValue();
        if (eqbdPremium !== 0) {
            this.OnRequestBindAndIssuePolicy();
            return;
        }

        const fallbackVersionRef = this.indicationQuoteService.getSelectedQuoteVersion();
        const fallbackVersionNo = Number(fallbackVersionRef?.versionNo ?? sessionStorage.getItem("versionNo"));
        const selectedVersionData =
            this.selectedQuote()
            || this.quoteCoverageVersions().find((item: any) => Number(item?.versionNo) === fallbackVersionNo)
            || fallbackVersionRef;

        const hasRestrictedHighBpp = this.hasRestrictedOccupancyHighBpp(selectedVersionData);
        if (hasRestrictedHighBpp) {
            this.OnRequestBindAndIssuePolicy();
            return;
        }

        const context = this.getEQBDReferralContext();
        const boundVersionNo = Number(selectedVersionData?.versionNo ?? fallbackVersionNo);
        if (!context || !boundVersionNo) {
            this.openEqbdConfirmationDialog();
            return;
        }

        this.indicationQuoteService.GetEQBDReferralDetails(context.id, context.type).subscribe({
            next: (response: any) => {
                const records = Array.isArray(response?.data)
                    ? response.data
                    : (Array.isArray(response) ? response : []);
                const matchedVersion = records.find((item: any) => Number(item?.versionNo) === boundVersionNo);
                const availability = matchedVersion?.isEQBDAvailabe;
                const skipPopup = availability !== null
                    && availability !== undefined
                    && availability !== ''
                    && Number(availability) === 0;

                if (skipPopup) {
                    this.OnRequestBindAndIssuePolicy();
                } else {
                    this.openEqbdConfirmationDialog();
                }
            },
            error: () => {
                this.openEqbdConfirmationDialog();
            }
        });
    }
    
    onReturnToDashboardMTA() {
        const dialog = this.dialog.open(ConfirmationDialogComponent, {
            data: { message: "Do you want to return to dashboard?" }
        });
        
        dialog.afterClosed().subscribe((result: boolean) => {
            if(result){
                const isQuoteMTA = sessionStorage.getItem('isQuoteMTA');
                if(isQuoteMTA){
                    this.policyService.declineMTAByBroker(Number(this.authService.getUserDetailsFromStorage()?.policyId), true)
                    .subscribe({
                        next: (response: any) => {
                            if(response){
                            this.indicationQuoteService.redirectToDashboard(); // redirect to dashboard
                            }
                        },
                        error: (error: any) => {
                            this.toastService.addNotification({message: "System error. Failed to save data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
                        }
                    })
                }else{
                    this.indicationQuoteService.redirectToDashboard(); // redirect to dashboard
                }
            }
        }); 
    }

    onSaveIndicationHomeAction() {
        const irStatus = String(sessionStorage.getItem("inceptionStatus"))
        const isreferral = Number(sessionStorage.getItem("isreferral"))
        
        if(isreferral !== 1){
        if(this.authService.isPolicyType()){
            this.onReturnToDashboardMTA();
        }else{
            if(this.indicationId() && this.branchId()) {
                const payloadRequest: any = {
                    indicationId : this.indicationId(),
                    branchId: this.branchId(),
                    userId: this.authService.getUserDetailsFromStorage().userDetails?.userId
                }
                this.saveIndicationHomeEmitter.emit(payloadRequest);
            }else{
                const payloadRequest: any = {
                    quoteId : this.authService.getUserDetailsFromStorage()?.quoteId,
                    branchId: this.branchId(),
                    userId: this.authService.getUserDetailsFromStorage().userDetails?.userId
                }
                this.saveIndicationHomeEmitter.emit(payloadRequest);
            }
        }
    }else{
         this.router.navigate(['/quote']);
    }
    }

    handleSaveStep() {
        if(this.authService.isPolicyType()){
            this.onSaveStep("4c", "Policy", String(this.authService.getUserDetailsFromStorage()?.policyId));
        }else{
            if(this.isIndicationType()){
                this.onSaveStep("4c", "Indication", String(this.indicationId()));
            }else{
                this.onSaveStep("4c", "Quote", String(this.authService.getUserDetailsFromStorage()?.quoteId));
            }
        }
    }

    onSaveStep(step: string, type: string, id: string) {
        if (this.isReadOnlyMode()) {
            return;
        }
        this.indicationQuoteService.saveStepForCurrentUser(step, type, id).subscribe({
            next: (response: any) => {
            },
            error: (error: any) => {
            }
        })
    }

    isIndicationType(): boolean {
        const quoteType = this.storageData()?.quoteType;
        return quoteType === "indication";
    }

    quoteComparion()
    {
        const dialogRef: MatDialogRef<QuoteComparisonComponent> = this.dialog.open(QuoteComparisonComponent,{
            width:'auto',
            minWidth:"800px",
           
          });
      
          dialogRef.afterClosed().subscribe(result => {
            if (!result) {
                return;
            }
            if (result?.action === 'amend') {
                this.OnAmendQuote();
                return;
            }
            if (result?.action === 'request-bind') {
                this.OnRequestBindAndIssuePolicy();
                return;
            }
            if (result?.action === 'selected') {
                if (result?.quote) {
                    this.bindRequestQuoteSummaryDataversion(result.quote);
                }
                return;
            }
            this.bindRequestQuoteSummaryDataversion(result)

            
          });
    }

    updateRagIndicationColor(feedBackType: string = "") {
        switch(feedBackType){
          case "GreenRange":
            this.ragIndicationColor.set("#238823");
            break;
          case "AmberRange":
            this.ragIndicationColor.set("#FFBF00");
            break;
          case "RedRange":
            this.ragIndicationColor.set("#FF0000");
            break;
          case "ReferralRedLow":
            this.ragIndicationColor.set("#FF0000");
            break;
          case "ReferralRedHigh":
            this.ragIndicationColor.set("#238823");
            break;
                  
          default:
            this.ragIndicationColor.set('#A99333')  // default gold color
        }
      }

    setIndicationQuoteRagDetails(response: any){
        this.updateRagIndicationColor(response.metricName);
      }

    fetchIndicationRagdetails(){     
          this.indicationQuoteService.getIndicationRating(Number(this.authService.getUserDetailsFromStorage()?.indicationId), Number(this.userId())).subscribe({
          next: (response: any) => {
            if(response){
              this.setIndicationQuoteRagDetails(response);                    
              this.indicationQuoteDetails.set(response);  
            }
          },
          error: (error: any) => {
            console.log("error", error);
          }
        })
      }

      fetchQuoteRagdetails(){
        const status = sessionStorage.getItem("statusRagCall");
        const statusAvailable = sessionStorage.getItem("statusAvailable");              
        const RagCall = sessionStorage.getItem("RagCall");

        if ( statusAvailable !== "true" || RagCall === "true"){
            this.indicationQuoteService.getQuoteRating(Number(this.authService.getUserDetailsFromStorage()?.quoteId), Number(this.userId())).subscribe({
            next: (response: any) => {
                if(response){
                this.setIndicationQuoteRagDetails(response);
                this.indicationQuoteDetails.set(response);
                }
            },
            error: (error: any) => {
                console.log("error", error);
            }
            })
        }else{
            this.getRagData();
        }
      }

          getRagData() {
           
            let type: string;
            let id : number;

            if (this.authService.isPolicyType()) {
                type = 'Policy';
                id = Number(this.authService.getUserDetailsFromStorage()?.policyId);
            } else if (this.isIndicationType()) { 
                type = 'Indication';
                id = Number(this.authService.getUserDetailsFromStorage()?.indicationId)
            } else {
                type = 'Quote';
                id = Number(this.authService.getUserDetailsFromStorage()?.quoteId)
            }

            this.indicationQuoteService.getPolicyRAG(id, type).subscribe(
                response => {
                this.setIndicationQuoteRagDetails(response);
                this.indicationQuoteDetails.set(response);             
                },
                error => {
                }
            );
            
        }

      calculateQuoteInspectionFees(){
        this.isLoading.set(true);
        const quoteId = Number(this.authService.getUserDetailsFromStorage()?.quoteId);
        const indicationQuoteId = this.isIndicationType() ? this.indicationId() : this.quoteId();
        const branchId = this.branchId();
        this.indicationQuoteService.QuoteInspectionFees(quoteId).subscribe({
            next: (response: any) => {
              if (response) {
                this.getQuoteSummaryDetails(Number(indicationQuoteId), Number(branchId));
              }
            },        
            error: (error: any) => {
                this.isLoading.set(false);
            },
        });
    }

    calculatePolicyInspectionFees(){
        this.isLoading.set(true);
        const policyId = Number(this.authService.getUserDetailsFromStorage()?.policyId)        
        this.indicationQuoteService.PolicyInspectionFees(policyId).subscribe({
            next: (response: any) => {
              if (response) {
                this.getPolicyCoverageSummaryDetails();
            }
            },        
            error: (error: any) => {
                this.isLoading.set(false);
            },
        });
    }

     submitQuoteReferral(){
        this.indicationQuoteService.submitReferralQuote(Number(this.quoteId()),Number(this.branchId())).subscribe({
            next: (response) => {
                if(response){
                    this.toastService.addNotification({message: "Your referral has been successfully submitted", type: ToastType.Success}); 
                    this.indicationQuoteService.removeIndicationQuoteStorageData()
                    this.router.navigate(['/quote'])
                }
            },
            error: (error) => {
                
            }
            })
        } 

        getQuoteConfig(){
            this.systemAdminService.getQuoteConfig().subscribe({
            next: (response: any) => {
                sessionStorage.setItem("maxVersionCount",response[0].versionMaxCount)
                 const versionNo = Number(sessionStorage.getItem('versionNo'))
                 const maxVersionCount = Number(response[0].versionMaxCount)
                 const status = sessionStorage.getItem("statusRagCall");
                    if(!this.isUwAdmin()){
                        if (versionNo > maxVersionCount){
                            this.maxAmendLock.set(true)                            
                        return
                        }else{
                            this.maxAmendLock.set(false)
                        }
                    }
            },
            error: (error: any) => {

            }
            })
        }

    getVersionNo(){
        return sessionStorage.getItem('versionNo');
      }

    versionLock(){
        const versionNumber  = this.getVersionNo() ? Number(this.getVersionNo()) : 1
        return
    }
    
}

